import { TabList, TabSlot, TabTrigger, Tabs } from 'expo-router/ui';

/** The tabs fill the screen, or each section's list grows the page instead of scrolling. */
const FILL = { flex: 1 } as const;

/**
 * The public sections on web, as tabs rather than stack pushes.
 *
 * A stack pushes a new copy of a section on every visit, so walking between sections kept each
 * visited copy mounted. Tabs mount each section once. With `fullHistory`, every switch still adds
 * a browser history entry and browser back walks the sections in visit order. `NavBar` is the
 * visible tab bar; this list only declares the tabs to the router, so it is hidden.
 */
export default function OpenSectionsLayout() {
  return (
    <Tabs style={FILL} options={{ backBehavior: 'fullHistory' }}>
      <TabSlot style={FILL} />
      <TabList style={{ display: 'none' }}>
        <TabTrigger name="directory" href="/directory" />
        <TabTrigger name="community" href="/community" />
        <TabTrigger name="content-library" href="/content-library" />
      </TabList>
    </Tabs>
  );
}
